import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "TU_API_KEY",
  authDomain: "mmdl-app.firebaseapp.com",
  projectId: "mmdl-app",
  storageBucket: "mmdl-app.firebasestorage.app", // <-- Debe coincidir exactamente
  messagingSenderId: "TUS_NUMEROS",
  appId: "TUS_NUMEROS"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);